import React from 'react'
import { IconDownload, IconFileDownload } from '@tabler/icons-react';
import getRandomColor from '../../getRandomColor';
import { _showToast } from '../../../toastHelper';

export default function DownloadCard(props) {
    return (
        <div className="col-md-3">
            <div className="main-card2 card-clickable card">
                <div className="g-0 align-items-center row">
                    <div className="col-md-12" style={{ minHeight: "160px", width: "100%" }}>
                        <div className="placeholder-glow position-relative"
                            style={{ borderRadius: "5px", boxSizing: "border-box", display: "inline-block", position: "relative", height: "200px", width: "100%" }}>
                            {!props.data.thumbnailPath && (
                                <div className="placeholder w-100 h-100" style={{ backgroundColor: getRandomColor(), opacity: "1" }}></div>)}
                            {props.data.thumbnailPath && props.data.thumbnailPath.trim() !== "" && (
                                <div style={{ position: "relative", height: "200px", width: "100%" }}>
                                    <img style={{ borderRadius: "15px 15px 0px 0px", objectFit: "contain", height: "100%", width: "100%"}}
                                        src={props.data.thumbnailPath} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="row align-items-center">
                        <div className="px-3 py-3 pb-0 card-body col-10">
                            <h4 className="card-title-big mb-0 text-truncate" style={{ fontSize: "1rem" }}>{props.data.name}</h4>
                        </div>
                        <div className="px-1 py-2 pb-0 card-body col-2">
                            <div className="d-flex gap-1 flex-wrap" style={{ justifyContent: "end" }}>
                                <a title="Download" href={props.data.filePath} download>
                                    <IconDownload size={20} />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}














